module.exports = __webpack_public_path__ + "2567b76fa21105d82f00aa84bd6e33f5.jpg";